import React from 'react';

export const notificationStatusOptions = [
  { label: "Todas", value: "todas", statusId: undefined },
  { label: "Abiertas", value: "abierta", statusId: 1 },
  { label: "Resueltas", value: "resuelta", statusId: 2 },
  { label: "Cerradas", value: "cerrada", statusId: 3 },
] as const;

export type NotificationStatusValue = typeof notificationStatusOptions[number]["value"];

interface NotificationFiltersProps {
  statusFilter: NotificationStatusValue;
  onStatusFilterChange: (value: NotificationStatusValue) => void;
}

export const NotificationFilters: React.FC<NotificationFiltersProps> = ({
  statusFilter,
  onStatusFilterChange,
}) => {
  return (
    <div className="flex gap-2 mb-6">
      {notificationStatusOptions.map((option) => (
        <button
          key={option.value}
          className={`px-4 py-1 rounded-full font-medium transition-colors
            ${
              statusFilter === option.value
                ? "bg-primary text-white shadow"
                : "bg-white text-primary border border-primary hover:bg-primary/10"
            }
          `}
          onClick={() => onStatusFilterChange(option.value)}
          type="button"
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}; 